import { z } from 'zod';
import { bulkCreateOrganizationTypes } from 'wasp/client/operations';
import type { CsvEntityConfig } from '../types';

const validationSchema = z.object({
  key: z.string().min(1, 'Key is required'),
  label: z.string().min(1, 'Label is required'),
  description: z.string().optional().default(''),
  icon: z.string().optional().default(''),
  isActive: z.string().optional().default('true'),
});

export const organizationTypeConfig: CsvEntityConfig = {
  entityName: 'Organization Types',
  entityNameSingular: 'Organization Type',
  columns: [
    { key: 'key', label: 'Key', required: true, description: 'Unique identifier (lowercase, no spaces)', exampleValue: 'Center' },
    { key: 'label', label: 'Label', required: true, description: 'Display name', exampleValue: 'Center' },
    { key: 'description', label: 'Description', required: false, description: 'Optional description', exampleValue: 'Community house of worship' },
    { key: 'icon', label: 'Icon', required: false, description: 'Lucide icon name', exampleValue: 'Building2' },
    { key: 'isActive', label: 'Is Active', required: false, description: 'true/false (default: true)', exampleValue: 'true' },
  ],
  validationSchema,
  exampleRows: [
    { key: 'Center', label: 'Center', description: 'Community house of worship', icon: 'Building2', isActive: 'true' },
    { key: 'school', label: 'Community School', description: 'Educational institution', icon: 'GraduationCap', isActive: 'true' },
  ],
  bulkCreateAction: bulkCreateOrganizationTypes as any,
};



